import {
    Checkbox,
    Chip,
    Container,
    FormControl,
    FormControlLabel,
    FormLabel,
    FormHelperText,
    FormGroup,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
    Divider
} from "@material-ui/core";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import React from "react";
import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";
import { SaspButton } from "./SaspButton";
import { CounterWidget } from "./CounterWidget"
import ModalIcon from "../components/ModalIcon";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
        backgroundColor: '#00567a',
        color: '#fff' 
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

function getStyles(index, key, theme) {
    return {
      fontWeight:
        key.indexOf(index) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
};

export const EditDeckForm = props => {
    const [name, changeName] = React.useState(props.name);
    const [summary, changeSummary] = React.useState(props.summary);
    const [checkYears, setCheckedYears] = React.useState(props.yearsObj);
    const [checkAreas, setCheckedAreas] = React.useState(props.areaObj);
    const [checkKeyword, setCheckedKeyword] = React.useState(props.keywords);
    const [checkQuestions, setQuestions] = React.useState(props.questionObj);
    const [myYears, setMyYears] = React.useState([]);
    const [myAreas, setMyAreas] = React.useState([]);
    const classes = useStyles();
    const theme = useTheme();
    const selectYears = Object.keys(props.yearsObj);

    const [state, setState] = React.useState({
        isHome: props.isHome,
        openBook: props.openBook,
        isPublic: props.isPublic,
        isSpaced: props.isSpaced,
        flashCards: props.flashCards,
        questionCount: props.questionCount,
        name: props.name,
        summary: props.summary,
        questionObj: props.questionObj,
        yearText:props.yearText,
        areaText:props.areaText
    });

    const updateChange = (obj) => {        
        switch(obj.type) {
            case 'year': {
                checkYears[obj.name] = obj.bool;
                break;
            }
            case 'area': {
                checkAreas[obj.name] = obj.bool;
                break;
            }
        }
    }

    const updateCount = async () => {
        let obj = {
            mcid: props.user_details.mcid,
            key: props.user_details.key,
            yearvar: myYears,
            gamemode: state.openBook ? 3 : 4,
            areavar: myAreas,
        };
        let c = await props.getQuestionCount(obj);
        setState({...state, questionCount: c});
    }

    const handleSwitchChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
        props.setProps(event.target.name, event.target.checked);
    }

    const handleYearChange = (event) => {
        let val = event.target.value;
        setMyYears(val);
        let test = Object.keys(checkYears);
        for (const i in test) {
            updateChange({
                type: 'year', 
                name: test[i].toString(), 
                bool: val.includes(test[i].toString())
            });
        }
    }

    const handleAreaChange = (event) => {
        let val = event.target.value;        
        setMyAreas(val);
        let test = Object.keys(checkAreas)
        for (const i in test) {
            updateChange({type: 'area', name: test[i].toString(), bool: val.includes(test[i].toString())});
        }
    }

    //TODO refactor to incorporate these into 1 handlechange function
    const handleKeyChange = name => event => {
        setCheckedKeyword({ ...checkKeyword, [name]: event.target.checked });
    };

    const handleNameChange = event => {
        changeName(event.target.value);
    };

    const handleSummaryChange = event => {
        changeSummary(event.target.value);
    };

    const handleQuestionChange = name => event => {
        setQuestions({ ...checkQuestions, [name]: event.target.checked });
        let temp = props.questionObj
        temp[name] = event.target.checked;
        
        let questionData = {
            mcid: props.auth_feedback.mcid,
            key: props.auth_feedback.key,
            deckID: props.deckID,
            questionID: name,
            isActiveQuestion: (event.target.checked ? 1 : 0)
        };
        props.addQuestionToDeck(questionData);
        props.setProps( 'questionObj', temp );
    };

    const createMarkup = props => {
        if (!props.includes('<p')) { props = '<p>' + props + '</p>'; }
        return { __html: props };
    };

    const mapQuestions = () => {
        console.log(props)
        if (props.questionArr) {
            return Object.keys(props.questionArr).map((question) => {
                return (
                    <TableRow>
                        <TableCell 
                            align="left"
                            style={{
                                verticalAlign:"top", 
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(props.questionObj[props.questionArr[question].QuestionID] ? true : false)}
                                        onChange={handleQuestionChange(props.questionArr[question].QuestionID)}
                                        value={checkQuestions[props.questionArr[question].QuestionID]}
                                        disabled={props.results.isWrong ? true : false}
                                    />
                                }
                            />
                        </TableCell>
                        <TableCell align="left">
                            <div className="text-blue font-strong margin-top-8">
                                SASP {props.questionArr[question].qYear} Question {props.questionArr[question].qNumber}
                            </div>
                            <div
                                dangerouslySetInnerHTML={createMarkup(
                                    props.questionArr[question].qtext
                                )}
                                style={{width: "100%"}}
                            ></div>
                        </TableCell>
                    </TableRow>
                )
            });
        } else {
            return (
                <p>No Questions:</p>
            )
        }
    };

    const mapKeywords = props => {
        return Object.keys(props.keywords).map((keyword, index) => {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkKeyword[keyword].value}
                            onChange={handleKeyChange(keyword)}
                            value={checkKeyword[keyword].value}
                        />
                    }
                    label={keyword}
                />
            );
        });
    };

    const ownerDiv = (data) => {
        return (
            <>
                <div className="margin-top-48 margin-bottom-16 margin-top-48" style={{
                    display:"flex",
                    justifyContent:"space-between",
                    alignItems: "center",
                    width: "100%"
                }}>
                    <SaspButton
                        className="text-white"
                        onClick={() => props.gapFunc({
                            years: checkYears, 
                            areas: checkAreas, 
                            keywords: checkKeyword, 
                            name: (name === 'filler' ? state.name : name), 
                            summary: (summary === 'filler' ? state.summary : summary),
                            isHome: state.isHome,
                            isPublic: state.isPublic,
                            isSpaced: state.isSpaced, 
                            openBook: state.openBook,
                            questionObj: state.questionObj,
                            isActive: 1,
                            flashCards: state.flashCards,
                            deckID: 0
                        })}
                    >
                        Update Deck
                    </SaspButton>

                    <SaspButton
                        className="deleteButton"
                        onClick={() => props.gapFunc({
                            years: checkYears, 
                            areas: checkAreas, 
                            keywords: checkKeyword, 
                            name: (name === '' ? props.name : name), 
                            summary: (summary === '' ? props.summary : summary),
                            isHome: props.isHome,
                            isPublic: props.isPublic,
                            isSpaced: props.isSpaced, 
                            openBook: props.openBook,
                            questionObj: props.questionObj,
                            isActive: 0
                        })}
                    >
                        Delete Deck
                    </SaspButton>
                </div>
            
                <Grid item xs={12} className="anchor margin-bottom-16 margin-top-16">
                    <Typography className="DividerText">Questions</Typography>
                    <Divider className="SASPDivider" />
                </Grid>

                {props.questionArr.length
                    ? (
                        <Grid item xs={12}>
                            <FormGroup>
                                <TableContainer class="margin-bottom-24" component={Paper}>
                                    <Table style={{width: "100%"}} aria-label="question table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell align="left"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mapQuestions(props)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </FormGroup>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <p>There are no questions associated with this deck.</p>
                        </Grid>
                    )
                }
                        
            </>
        )   
    }

    const icon = props.icons;

    return (
        <Container className="aua-overflow createDeckFormContainer" maxWidth="xl">
            <Grid container className="mainContainer margin-top-8">
                <Grid item xs={12} className="anchor margin-bottom-16">
                    <CounterWidget 
                        count={props.questionCount}
                        textColor="#fff"
                        backgroundColor="#00567a"
                    /> 
                    <Typography className="DividerText">Edit Deck</Typography>
                    <Divider className="SASPDivider" />
                </Grid>

                <Grid item xs={12}>
                    {props.results.owner 
                        ? (
                            <TextField
                                label="Deck Name"
                                value={name}
                                onChange={handleNameChange}
                            />
                        ) 
                        : (
                            <div className="margin-bottom-16 margin-top-12">
                                <div className="text-blue font-strong margin-bottom-4">Deck Name</div>
                                <div>{name}</div>
                            </div>
                        )}
                </Grid>

                <Grid item xs={12}>
                    {props.results.owner 
                        ? (
                            <TextField
                                label="Deck Summary"
                                value={summary}
                                onChange={handleSummaryChange}
                                multiline
                                rowsMax={10}
                                rows={1}
                            />
                        )
                        : (
                            <div className="margin-bottom-16 margin-top-12">
                                <div className="text-blue font-strong margin-bottom-4">Deck Summary</div>
                                <div>{summary}</div>
                            </div>
                        )
                    }
                </Grid>

                {!props.results.isWrong
                    ? (
                        <>
                            <Grid item xs={12} className="margin-bottom-16 margin-top-12">
                                <div className="text-blue font-strong margin-bottom-4">Subscription Years</div>
                                <div style={{color:"var(--aua-theme-soft-blue)"}}>{props.yearText()}</div>
                            </Grid>

                            <Grid item xs={12} className="margin-bottom-16">
                                <div className="text-blue font-strong margin-bottom-4">Topics</div>
                                <div  style={{color:"var(--aua-theme-soft-blue)"}}>{props.areaText()}</div>
                            </Grid>
                        </>
                    )
                    : null
                }
                <Grid item xs={12} className="anchor margin-top-24">
                    <Typography className="DividerText">Options</Typography>
                    <Divider className="SASPDivider" />
                    
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch 
                                            checked={props.isHome} 
                                            onChange={handleSwitchChange} 
                                            name="isHome" 
                                        />}
                                    label="Add to Home"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Home Deck'}
                            icon={'info'}
                            body={icon.home}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                {props.results.owner 
                                    ? (
                                        <FormControlLabel
                                            control={<Switch checked={props.openBook} onChange={handleSwitchChange} name="openBook"  />}
                                            label="Open Book"
                                        />
                                    ) : (
                                        <FormControlLabel
                                            control={<Switch checked={props.openBook} onChange={handleSwitchChange} name="openBook"  />}
                                            label="Open Book"
                                            disabled={true}
                                        />
                                    )
                                }
                                    
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Open Book'}
                            icon={'info'}
                            body={icon.open}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                {props.results.owner 
                                    ? (
                                        <FormControlLabel
                                            control={<Switch checked={props.isSpaced} onChange={handleSwitchChange} name="isSpaced"  />}
                                            label="Spaced Learning"
                                        />
                                    ) 
                                    : (
                                        <FormControlLabel
                                            control={<Switch checked={props.isSpaced} onChange={handleSwitchChange} name="isSpaced"  />}
                                            label="Spaced Learning"
                                            disabled={true}
                                        />
                                    ) 
                                }
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Spaced Learning'}
                            icon={'info'}
                            body={icon.spaced}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                {props.results.owner 
                                    ? (
                                        <FormControlLabel
                                            control={<Switch checked={props.isPublic} onChange={handleSwitchChange} name="isPublic" />}
                                            label="Public"
                                        />
                                    ) 
                                    : (
                                        <FormControlLabel
                                            control={<Switch checked={props.isPublic} onChange={handleSwitchChange} name="isPublic" />}
                                            label="Public"
                                            disabled={true}
                                        />
                                    ) 
                                }
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title='Public Deck'
                            icon='info'
                            body={icon.public}
                            color='#7c878e'
                            className="margin-left-16"
                        />
                    </div>
                </Grid>
                
                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={props.flashCards} onChange={handleSwitchChange} name="flashCards"  />}
                                    label="Flashcards"
                                />                                    
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Flashcards'}
                            icon={'info'}
                            body={icon.flashcards}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                {props.results.owner
                    ? (
                        ownerDiv(props.results)
                    ) 
                    : (
                        <div className="margin-top-48 margin-bottom-16" style={{
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems: "center",
                            width: "100%"
                        }}>
                            <SaspButton
                                className="deleteButton"
                                onClick={() => props.gapFunc({
                                    years: checkYears, 
                                    areas: checkAreas, 
                                    keywords: checkKeyword, 
                                    name: (name === '' ? props.name : name), 
                                    summary: (summary === '' ? props.summary : summary),
                                    isHome: props.isHome,
                                    isPublic: props.isPublic,
                                    isSpaced: props.isSpaced, 
                                    openBook: props.openBook,
                                    questionObj: props.questionObj,
                                    isActive: 0
                                })}
                            >
                                Unsubscribe
                            </SaspButton>
                        </div>
                    )
                }

            </Grid>
        </Container>
    );
};